import React, { useEffect, useState, useRef } from "react";
import BaseService from "services/BaseService";
import { withTranslation } from "react-i18next";
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import InventoryService from "services/Admin/InventoryService";
import {
  FileMetaData,
  FilePreviewContainer,
  FileUploadContainer,
  FormField,
  ImagePreview,
  PreviewContainer,
  PreviewList,
  RemoveFileIcon,
  ShowContent,
  UploadFileBtn,
} from "components/Common/file-upload/file-upload.styles";

const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 50000000;

const FileUpload = ({
  label,
  attachmentType,
  attachmentData,
  updatedAttachment,
  deleteAttachment,
  setColumns,
  maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  setUploadState = () => { },
  ...otherProps
}) => {
  const cancelTokenSource = useRef();
  const AuthData = useSelector(state => state.Auth)
  const { t } = useTranslation();
  const fileInputField = useRef(null);
  const [percent, setPercent] = useState(0)
  const [files, setFiles] = useState([]);
  const [lastAddedFiles, setLastAddedFiles] = useState([]);
  const [error, setError] = useState(false)
  const [errorText, setErrorText] = useState('')

  useEffect(() => {
    let uploadState = percent === 0 ? false : percent === 100 ? false : true
    setUploadState(uploadState)
  }, [percent])
  useEffect(() => {
    setFiles(attachmentData);

    return () => {
      cancelTokenSource ?.current ?.cancel()
    }
  }, [attachmentData]);

  const handleUploadBtnClick = () => {
    fileInputField.current.click();
  };

  const addNewFiles = (newFiles) => {
    let files = [];
    for (let file of newFiles) {
      if (file.size <= maxFileSizeInBytes) {
        if (!otherProps.multiple) {
          otherProps.setFile(file)
          return [file];
        }
        files.push(file);
      }
    }
    return files;
  };

  const handleNewFileUpload = async (e) => {
    otherProps?.setUpload(true)
    const { files: newFiles } = e.target;
    if (newFiles.length) {
      let updatedFiles = addNewFiles(newFiles);
      //TODO enhance if 50 file will send 50 ajax
      let createdFiles = [];
      let columns = [];
      cancelTokenSource.current = axios.CancelToken.source();
      const options = {
        cancelToken: cancelTokenSource.current.token,
        ignoreInterceptors: true,
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          let percentValue = (loaded * 100) / total
          setPercent(percent => {
            const value = (percentValue - percent) / updatedFiles.length
            const updatedPercentage = value + percent
            if (percent > updatedPercentage) {
              return percent
            } else {
              return updatedPercentage
            }
          })
        }
      }
      Promise.all(
        updatedFiles.map(async (file) => {
          let coulmnsRes = await new InventoryService().getColumns(file);
          if(typeof coulmnsRes == "string"){
            setError(true)
            setErrorText(coulmnsRes)
            return
          }else{
            columns = coulmnsRes ?.data;
            setError(false)
          }

          let res =await new BaseService().postUploadOther(file, options);
          const createdFile = res ?.data ?.data;
          createdFiles.push(createdFile);
        }),
      ).then(() => {
        otherProps?.setUpload(false)
        if (!otherProps.multiple) {
          setFiles(createdFiles);
        } else {
          setFiles([...files, ...createdFiles]);
        }
        setPercent(0)
        let cols=[]
        for (let key in columns) {
          cols.push({label: columns[key], value: columns[key]})
        }
        setColumns([...cols])
        setLastAddedFiles(createdFiles);
      }).catch((err) => {
        otherProps?.setUpload(false)
        setPercent(0)
      })
    }
  };

  useEffect(() => {
    if (lastAddedFiles.length) {
      updatedAttachment(lastAddedFiles, attachmentType);
    }
  }, [lastAddedFiles]);

  const removeFile = async (id) => {
    await setFiles((files) => []);
    const updatedFiles = files.filter((f) => f.id !== id);
    setFiles((files) => [...updatedFiles]);
    deleteAttachment(
      files.filter((f) => f.id === id),
      attachmentType,
    );
  };

  return (
    <>
            <p className={error ? "error float-left my-0":"float-left my-0"}>{label}</p>

      <FileUploadContainer>
        <UploadFileBtn type='button' onClick={handleUploadBtnClick}>
          <i className='fas fa-file-upload' />
          <span>{t(`Upload ${otherProps.multiple ? "files" : "a file"}`)}</span>
        </UploadFileBtn>
        <FormField
          type='file'
          ref={fileInputField}
          onChange={handleNewFileUpload}
          title=''
          value=''
          {...otherProps}
        />
      </FileUploadContainer>
      {percent > 0 &&
        <div className="progress">
          <div
            className="progress-bar progress-bar-striped"
            role="progressbar"
            style={{ width: percent + '%' }}
            aria-valuenow={`${percent}`}
            aria-valuemin="0"
            aria-valuemax="100"
          >
          </div>
        </div>
      }
      {!error ?<FilePreviewContainer>
        <PreviewList>
          {
            files ?.map((file, index) => {
              if (file ?.path) {
                return (
                  <PreviewContainer key={index}>
                    <div>
                      <ImagePreview
                        src={file.path}
                        alt={`file preview ${index}`}
                      />

                      <FileMetaData>
                        <aside>
                          <RemoveFileIcon
                            className='fas fa-trash-alt'
                            onClick={() => removeFile(file.id)}
                          />
                          <ShowContent
                            href={file.path}
                            target='_blank'
                            rel='noopener noreferrer'>
                            <RemoveFileIcon className='fas fa-eye' />
                          </ShowContent>
                        </aside>
                      </FileMetaData>
                    </div>
                  </PreviewContainer>
                );
              }
            })}
        </PreviewList>
      </FilePreviewContainer> : <p className="error">{errorText}</p>}
    </>
  );
};

export default withTranslation()(FileUpload);
